import { Icon } from 'components/lib';
import React from 'react';
import styles from '../styles.module.scss';

export function SelectEndorsementType({ setStage, resetModal }) {
  return (
    <div className={styles.insideWrapper}>
      <div className={styles.title}>
        Please select which endorsement you would like
        to make
      </div>
      <div className={styles.line} />
      <div className={styles.types}>
        <div className={styles.left}>
          <div
            className={styles.type}
            onClick={() => {
              setStage('add_vehicle_or_trailer');
            }}
          >
            <Icon
              image="plus-square"
              size={20}
              color="#fff"
            />
            <span>Add a Vehicle or Trailer</span>
          </div>
          <div
            className={styles.type}
            onClick={() => {
              setStage('remove_vehicle_or_trailer');
            }}
          >
            <Icon
              image="minus-square"
              size={20}
              color="#fff"
            />
            <span>Remove a Vehicle or Trailer</span>
          </div>
          <div
            className={styles.type}
            onClick={() => {
              setStage('additional_interest');
            }}
          >
            <Icon
              image="plus-square"
              size={20}
              color="#fff"
            />
            <span>Add and Additional Interest</span>
          </div>
        </div>
        <div className={styles.right}>
          <div
            className={styles.type}
            onClick={() => {
              setStage('add_driver');
            }}
          >
            <Icon
              image="plus-square"
              size={20}
              color="#fff"
            />
            <span>Add a driver</span>
          </div>
          <div
            className={styles.type}
            onClick={() => {
              setStage('remove_driver');
            }}
          >
            <Icon
              image="minus-square"
              size={20}
              color="#fff"
            />
            <span>Remove a driver</span>
          </div>
          <div
            className={styles.type}
            onClick={() => {
              setStage('other_endorsement');
            }}
          >
            <span>Quote Only/Other</span>
          </div>
        </div>
      </div>
      <div
        className={styles.footer}
        style={{
          justifyContent: 'space-between',
          marginTop: 20,
        }}
      >
        <div className={styles.buttons}>
          <button
            className={styles.cancel}
            onClick={() => {
              resetModal();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
